import { customizeError } from '@chilecompra/react-kit'
import { makeActionCreator } from '../../config/store/utils'
import { getInstitutionalManagement } from '../../services/buyer'

export const GET_INSTITUTIONAL_MANAGEMENT = 'GET_INSTITUTIONAL_MANAGEMENT'
export const GET_INSTITUTIONAL_MANAGEMENT_ERROR = 'GET_INSTITUTIONAL_MANAGEMENT_ERROR'
export const GET_INSTITUTIONAL_MANAGEMENT_SUCCESS = 'GET_INSTITUTIONAL_MANAGEMENT_SUCCESS'
export const onGetInstitutionalManagement = makeActionCreator(GET_INSTITUTIONAL_MANAGEMENT)
export const onGetInstitutionalManagementError = makeActionCreator(GET_INSTITUTIONAL_MANAGEMENT_ERROR, 'payload')
export const onGetInstitutionalManagementSuccess = makeActionCreator(GET_INSTITUTIONAL_MANAGEMENT_SUCCESS, 'payload')
export const onGetInstitutionalManagementThunk = payload => async dispatch => {
  dispatch(onGetInstitutionalManagement())

  try {
    const { data } = await getInstitutionalManagement({ actionType: GET_INSTITUTIONAL_MANAGEMENT, dni: payload.dni })

    const authorities = data?.payload || []

    const authoritiesList = authorities.map(authority => {
      return {
        firstName: authority.nombre,
        lastName:
          authority.apellido.toLowerCase() === 'sin información' ||
          authority.apellido.toLowerCase() === 'sin informacion'
            ? ''
            : authority.apellido,
        email: authority.email,
        phone: authority.telefono,
        type: authority.tipoRepresentante
      }
    })

    const representativeList = authoritiesList.filter(rep => rep.type === 1)
    const administratorList = authoritiesList.filter(rep => rep.type === 2)

    return dispatch(
      onGetInstitutionalManagementSuccess({
        representativeList,
        administratorList
      })
    )
  } catch (error) {
    if (error?.originalError?.code === 'ERR_CANCELED') {
      return
    }
    let reason
    switch (error.code) {
      case 401:
        reason = 'UNAUTHORIZED_ERROR'
        break
      case 403:
        reason = 'FORBIDDEN_ERROR'
        break
      default:
        reason = 'SOMETHING_WENT_WRONG_ERROR'
        break
    }
    return dispatch(
      onGetInstitutionalManagementError({
        error: customizeError({ originalError: error?.originalError, code: error.code, reason }).toObject()
      })
    )
  }
}
